import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CustomFormControl} from '../../CustomFormControl';
import {KeyValuePipe} from '@angular/common';

@Component({
    selector: 'app-control-error-list',
    templateUrl: './control-error-list.component.html',
    styleUrls: ['./control-error-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        KeyValuePipe
    ]
})
export class ControlErrorListComponent implements OnInit {

  @Input() control!: CustomFormControl;

  constructor() { }

  ngOnInit(): void {
  }

  getErrorMessage(errorKey: string, errorValue: any): string {
    switch (errorKey) {
      case 'required':
        return 'This field is required';
      case 'minlength':
        return `Minimum length is ${errorValue.requiredLength} characters`;
      case 'maxlength':
        return `Maximum length is ${errorValue.requiredLength} characters`;
      case 'invalidZip':
        return 'The zip code must be 5 or 9 characters';
      case 'invalidAin':
        return 'The AIN provided is invalid';
      case 'notPersonalPropertyIsRealProperty':
        return 'The AIN provided is not personal property, it is real property';
      case 'noCountyEmail':
        return 'LA County emails are forbidden';
      case 'noFutureDates':
        return 'The date cannot be in the future';
      case 'invalidSsn':
        return 'The SSN provided is invalid';
      case 'regexValidator':
        return 'The data was not in the expect format';
      case 'signixEmailTooLong':
        return 'The input email cannot exceed 50 characters';
      case 'requiredCheckbox':
        return 'You must acknowledge this statement to continue';
      case 'inequality':
        return this.control.element.equalityValidator.customErrorMessage;
      case 'noCheckboxesSelected':
        return errorValue;
      case 'min':
        return `Minimum value is ${errorValue.min}`;
      case 'max':
        return `Maximum value is ${errorValue.max}`;
      case 'email':
        return 'The provided email is invalid';
      case 'alphanumeric':
        return 'The provided value must be alphanumeric (no spaces or special characters)';
      case 'signixNameField':
        return 'This field must only contain characters commonly found in names. Update this in My Account > Profile.';
      case 'signixFieldTooLong':
        return `This field exceeded the maximum length allowed. Please remove ${errorValue.trimBy} characters.`;
      default:
        return `No error found for ${errorKey}`;
    }
  }
}
